import { Box, styled, Typography } from '@mui/material';

import { Card } from 'Components';
import loginBackground from 'Images/loginBackground.jpeg';
import { Spacing } from 'Themes/spacing';

export const MainGrid = styled(Box)`
  background-image: url(${loginBackground});
  min-height: 100svh;
  display: flex;
  align-content: center;
  align-items: center;
`;

export const InnerGrid = styled(Box)`
  padding: ${Spacing.large};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  flex: 1;
  max-width: 525px;
  min-width: 400px;
  display: flex;
  flex-direction: column;
`;

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: ${Spacing.large};
`;

export const StyledBannerTittle = styled(Typography)`
  max-width: 300px;
  text-align: center;
`;

export const SideBanner = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const Banner = styled('img')`
  max-width: 415px;
`;
